const baseUrl = window.location.protocol + "//" + window.location.hostname + window.location.pathname;

let host = window.location.hostname;

let api_url = 'https://api.chowman.net/api/v4/';
// let socket_url = 'https://dashboard.chowman.net:8000';
let socket_url = 'https://socket.chowman.net:8000';
let image_baseUrl = 'https://dashboard.chowman.net/public/';
let s3_storage_url = 'https://chowman-media.s3.ap-south-1.amazonaws.com/';
let vendor_id = 40818;
let mapKey = 'AIzaSyCp0aF0BT2UlJft_pzDK0yFKH5be-ydcJQ';
let razor_pay_key ="rzp_live_VDfBRe8j0XxiHe";
let encryption_key = "TLHhwJEOU+5Euw3DSAnZCfYNY8TR6rQ2jkfkY8p5Wqk=";
let withoutEncrytption = ['update_profile','sendmessage']; // add route for avoid data encryption

if (host == 'localhost') {
    api_url = 'https://stg-api.chowman.net/masterchange/api/v4/';
    socket_url = 'https://stg-socket.chowman.net:8000';
    image_baseUrl = 'https://dev.chowman.net/public/';
    s3_storage_url = 'https://chowmanstorage.s3.ap-south-1.amazonaws.com/';
    razor_pay_key ="rzp_test_IyOoI9nuqsZhiD";
    encryption_key = "TLHhwJEOU+5Euw3DSAnZCfYNY8TR6rQ2jkfkY8p5Wqk=";
    mapKey = 'AIzaSyCp0aF0BT2UlJft_pzDK0yFKH5be-ydcJQ';
}
export default {
    appurl: baseUrl,
    base_folder: +window.location.pathname, //'/deonde/', // put base folder path here
    coupon: image_baseUrl + 'media/Coupon/',
    applogo: s3_storage_url + 'media/foodapp/original/',
    imageUrl:image_baseUrl,
    google_key: window.google_map_key,
    s3_storage_url:s3_storage_url,
    //api_url: 'https://dashboard.chowman.net/master/api/v3/',
    //api_url: 'http://3.111.195.250/api/v3/',

    /********** Dev Server *************/
    // api_url: 'https://dev.chowman.net/newv4/v4/api/v3/',
    // socket_url: 'https://dev.chowman.net:8000',

    /********** Live  Server *************/
    // api_url: 'https://api.chowman.net/api/v3/',
    // socket_url: 'https://dashboard.chowman.net:8000',

    api_url: api_url,
    socket_url: socket_url,
    vendor_id,
    mapKey:mapKey,
    razor_pay_key,
    encryption_key,
    withoutEncrytption
}